export default __webpack_public_path__ + "static/media/icon.3b732a74.svg";